import { useState } from "react";

export function useSetupEncryptionForm() {
  const [formValues, setFormValues] = useState<{
    password: string;
    confirmPassword: string;
    acknowledged: boolean;
    acknowledgedLimitedFunctionality: boolean;
  }>({ password: "", confirmPassword: "", acknowledged: false, acknowledgedLimitedFunctionality: false });

  const [errors, setErrors] = useState<{
    password?: string;
    confirmPassword?: string;
    acknowledged?: string;
    acknowledgedLimitedFunctionality?: string;
  }>({});

  const handleChange = (field: string, value: string | boolean) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validateForm = () => {
    const newErrors: {
      password?: string;
      confirmPassword?: string;
      acknowledged?: string;
      acknowledgedLimitedFunctionality?: string;
    } = {};

    if (!formValues.password) {
      newErrors.password = "Master password is required.";
    } else if (formValues.password.length < 8) {
      newErrors.password = "Master password must be at least 8 characters.";
    }

    if (!formValues.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    } else if (formValues.password !== formValues.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    if (!formValues.acknowledged) {
      newErrors.acknowledged = "You must acknowledge the warning.";
    }

    if (!formValues.acknowledgedLimitedFunctionality) {
      newErrors.acknowledgedLimitedFunctionality = "You must acknowledge the limited functionality.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormValues({ password: "", confirmPassword: "", acknowledged: false, acknowledgedLimitedFunctionality: false });
    setErrors({});
  };

  return { formValues, handleChange, resetForm, errors, validateForm };
}
